import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enLocale from '@td-analytics/iview-lite/dist/locale/en-US';
import zhLocale from '@td-analytics/iview-lite/dist/locale/zh-CN';

Vue.use(VueI18n);
Vue.locale = () => { };

// 解析文件列表
function loadByFile(fileList) {
  fileList.keys().forEach(key => {
    const fileClass = fileList(key).default;
    Object.assign(zhLocale, fileClass['zh-CN']);
    Object.assign(enLocale, fileClass['en-US']);
  });
}

// 加载文件目录
const fileList = require.context('./locale-module', false, /\.js$/);
loadByFile(fileList);

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'zh-CN',
  messages: {
    'zh-CN': zhLocale,
    'en-US': enLocale,
  }
});

// Vue.localCfg = { i18n };
export default i18n;
